<!--
    描述：项目管理模块入口页面
    时间：2020-05-15
    Created by ws
-->
<template>
	<transition name="fade"
				mode="out-in">
		<router-view></router-view>
	</transition>
</template>

<script>
export default {
	name: 'Project-management',
	data() {
		return {}
	},
	methods: {}
}
</script>

<style scoped lang="less">
</style>

